<i18n lang="yaml">
  pt:
    support: "Suporte"
    findProject: "Procure pelo seu projeto"
    documentation: "Documentação"
</i18n>

<template>
  <header class="header">
    <div class="header__wrapper wrapper row grid--nowrap grid--va-center">
      <router-link
        hidden
        to="/"
        title="Increazy Dash"
        class="header__logo d-block"
      >
        <figure
          data-grid
          class="grid--va-center m-0 h-100"
        >
          <img
            width="45"
            height="45"
            class="h-100"
            alt="Increazy Dash"
            :src="require('../../../assets/images/logos/dash-square-light.webp')"
          >
        </figure>
      </router-link>

      <SearchInput
        v-model.lazy="searchValue"
        :placeholder="$t('findProject')"
        class="header__search"
      />

      <HelpDropdown class="header__help ms-auto" />

      <figure
        v-if="false"
        data-grid
        class="header__notification grid--va-center grid--center m-0 cursor-pointer full-rounded p-relative has-tooltip"
      >
        <BellIcon />

        <TooltipApp>
          <ul class="tooltip__links">
            <li
              v-for="n in 10"
              :key="n"
            >
              notificação de número {{ n }}
            </li>
          </ul>
        </TooltipApp>
      </figure>

      <div class="vertical-divider" />

      <UserApp />
    </div>
  </header>
</template>

<script>
import { defineComponent } from 'vue'

import BellIcon from '../../../icons/BellIcon'
import UserApp from '../components/UserApp.vue'
import TooltipApp from './components/TooltipApp'
import SearchInput from '../../../global/SearchInput'
import HelpDropdown from '../../../global/HelpDropdown'

export default defineComponent({
  name: 'HeaderApps',

  components: {
    UserApp,
    BellIcon,
    TooltipApp,
    SearchInput,
    HelpDropdown
  },

  data: () => ({
    searchValue: ''
  }),

  watch: {
    searchValue (term) {
      setTimeout(() => {
        this.setFilter('apps.query', term.trim())
      }, 700)
    }
  }
})
</script>

<style lang="scss" scoped>
  .header {
    background: linear-gradient(90.89deg, var(--primary) 0%, var(--primary-light) 99.79%);

    &__wrapper {
      height: var(--header-height);

      .userapp {
        width: max-content;
      }
    }

    &__logo {
      width: 45px;
      margin-inline: 0 28px;
    }

    &__search {
      height: 45px;
    }

    :deep(.search__input) {
      height: 100%;
      display: flex;
      align-items: center;
    }

    :deep(.search__input input) {
      height: 30px;
    }

    .search {
      display: none;
    }

    &__help,
    &__notification {
      width: 40px;
      height: 40px;

      color: var(--primary);
      background-color: rgb(var(--white));

      :deep(svg) {
        width: 19px;
      }
    }

    &__notification {
      margin-left: calc(var(--gap) * 2);
    }

    .vertical-divider {
      display: none;
      width: 1px;
      height: 48px;

      margin: 0 calc(var(--gap) * 2);
      background-color: lighten(#00cae8, 45%);
      opacity: 0.5;
    }

    @media (min-width: 1024px) {
      .search {
        display: initial;
      }

      .vertical-divider {
        display: initial;
      }
    }
  }
</style>
